import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/app-shell.js';
import { AuthGuard } from './components/auth-guard.js';
import { LoginConfirmPage } from './pages/login-confirm.js';
import { LoginPage } from './pages/login.js';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* #18: außerhalb des AuthGuard (der Nutzer hat noch keine Session) und vor der */}
      {/* /*-Catch-All, sonst würde AppShell/AuthGuard den Pfad zuerst greifen. */}
      <Route path="/login/confirm" element={<LoginConfirmPage />} />
      <Route
        path="/*"
        element={
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        }
      />
    </Routes>
  );
}
